import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { ConfirmacaoResenha } from 'src/app/shared/validators/confirmacao-resenha';

@Component({
  selector: 'app-modal-redefinir-senha',
  templateUrl: './modal-redefinir-senha.component.html',
  styleUrls: ['./modal-redefinir-senha.component.scss'],
})
export class ModalRedefinirSenhaComponent {
  form: any;
  tipoInputSenha = 'password';
  tipoInputNovaSenha = 'password';
  tipoInputResenha = 'password';
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalRedefinirSenhaComponent>
  ) {}

  async ngOnInit() {
    this.form = this.fb.group(
      {
        senhaAtual: new FormControl('', Validators.required),
        senha: new FormControl('', Validators.required),
        resenha: new FormControl('', Validators.required),
      },
      { validators: ConfirmacaoResenha.MatchValidator }
    );
  }

  async alterarSenha() {
    const id = localStorage.getItem('id') || sessionStorage.getItem('id');
    const email =
      localStorage.getItem('email') || sessionStorage.getItem('email');
    const form = this.form.getRawValue();

    try {
      const senhaAtualValida = await this.usuarioService.validarSenha({
        id,
        senha: form.senhaAtual,
      });
      if (!senhaAtualValida) {
        await this.toastr.error('Senha atual incorreta.');
        return;
      }
      await this.usuarioService.redefinirSenha(id!, { senha: form.senha, usarCodigo: false });
      await this.toastr.success('Senha atualizada com sucesso!');
      this.cancelarDialogo();
    } catch (error) {
      console.log(error);
      await this.toastr.error(
        'Ocorreu algum erro, tente novamente mais tarde.'
      );
    }
  }

  mostrarEsconderSenha() {
    this.tipoInputSenha === 'password'
      ? (this.tipoInputSenha = 'text')
      : (this.tipoInputSenha = 'password');
  }
  mostrarEsconderNovaSenha() {
    this.tipoInputNovaSenha === 'password'
      ? (this.tipoInputNovaSenha = 'text')
      : (this.tipoInputNovaSenha = 'password');
  }
  mostrarEsconderResenha() {
    this.tipoInputResenha === 'password'
      ? (this.tipoInputResenha = 'text')
      : (this.tipoInputResenha = 'password');
  }

  cancelarDialogo(): void {
    this.dialogRef.close({ event: false });
  }
}
